import React from "react";
import { c_062 } from "../../resources/ClassNames";
import "./../../styles/components/utils/PageTitle.css";

function PageTitle({ title }) {
  return <div className={c_062}>{title}</div>;
}

export default PageTitle;
